import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import Helmet from 'react-helmet';
import BookmarkStore from '../../stores/BookmarkStore';
import BookmarksList from '../../components/BookmarksList';
import styles from './index.sass';

class BookmarksContainer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps(store) {
    let description = `Your Saved Products – ${store.name}`;
    let title = description;
    return {
      title: title,
      meta: [
        {name: 'description', content: description},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {property: 'og:url', content: this.props.currentRoute.absolute_url},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description}
      ]
    };
  }

  render() {
    let { bookmarksState, store } = this.props;
    let bookmarksListProps = {
      ...bookmarksState,
      loading: bookmarksState.loading || !this.props.isNavigateComplete,
      store: store
    };
    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(store)} />
        <BookmarksList {...bookmarksListProps} />
      </section>
    );
  }
}

BookmarksContainer = connectToStores(BookmarksContainer, [BookmarkStore], (context, props) => {
  return {
    bookmarksState: context.getStore(BookmarkStore).getCurrentState()
  };
});

export default BookmarksContainer;



// WEBPACK FOOTER //
// banquet/containers/BookmarksContainer/index.js